export default "__VITE_ASSET__BXsf_wbR__"